<template>
    <li class="dialog-tree-row" v-bind:class="{'bg-highlight':hidden}">

        <div v-if="!loading">
            <div v-if="!editing && $store.claims.dialogs & 2 && $store.claims.phrases & 2"  class="edit-icons">
                <div class="icon-container">
                    <DropDown v-if="!dialog.new" :actions="dropdownActions" :tag="dialog.tags" />
                    <span v-else class="icon-spacer right"></span>
                    <i v-if="!isStart" class='material-icons right grey-text text-darken-1' @click="edit()">edit</i>
                    <i v-if="!isStart" class='material-icons right grey-text text-darken-1' @click="editTag">bookmark</i>
                    <span v-if="!isStart">
                     <i v-if="isHidden()" class='material-icons right grey-text text-darken-1' @click="unhideDialog()">visibility_off</i>
                     <i v-else class='material-icons right grey-text text-darken-1' @click="hideDialog()">visibility</i>

                      <i v-if="dialog.type === 'answer'" >
                        <a class='dropdown-trigg btn btn-floating btn-small btn-flat transparent' :data-target="'dropdown' + dialog.id">
                        <i  class='material-icons right grey-text text-darken-1' v-bind:style="{color:currentColor}">
                          <p id="indicatorIcon" v-bind:style="{color:currentColor}" >fiber_manual_record</p></i>
                        </a>
                      <ul :id="'dropdown' + dialog.id" class='dropdown-content'>
                        <li @click="critcalLevelIndicator(0,dialog.id)"><a>1</a></li>
                        <li @click="critcalLevelIndicator(1,dialog.id)"><a>2</a></li>
                        <li @click="critcalLevelIndicator(2,dialog.id)"><a>3</a></li>
                        <li @click="critcalLevelIndicator(3,dialog.id)"><a>4</a></li>
                        <li @click="critcalLevelIndicator(4,dialog.id)"><a>5</a></li>
                      </ul>
                    </i>
                    </span>
                </div>
            </div>
            <div :id="dialog.id" @click="toggle" v-if="!editing" class="text-preview" @dragstart="onDragStart" @drop="onDrop" @dragover="allowDrop"
                :draggable="!isStart" v-bind:class="{'grey-text text-darken-1': isStart}" >
                <span v-if="!isStart && displaySecondaryLanguage" class="number-badge">{{itemNumber}}</span>

                <img v-if="$store.dialogHasImage[dialog.id]" :src='$store.dialogHasImage[dialog.id]' v-on:click="upload($event,'fromimage')" :id="dialog.id"  width="20" height="20"/>
                <i v-else class="material-icons " v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}" v-on:click="upload($event,icon)" :id="dialog.id">{{icon}}</i>
                

                <div class="preview-div">
                {{ primaryTranslation }}

                <div v-if="!isStart && displaySecondaryLanguage" dir="auto" class="secondary-language">{{ secondaryTranslation }}</div>

                </div>
                <div v-if="icon=='feedback' && $store.instructionAttachments[dialog.id]" :id="'instruction-images-'+dialog.id" >
                  <div class="instruction-image-wrapper">
                    <img v-for="(attach,index) in $store.instructionAttachments[dialog.id]" :key="index" :id="'img-' + index" v-if="attach.type == 'image'" :src="attach.data" @click="upload($event,'editInstImg',index);selectedInstructionAttachment(attach.id,index)" style="height:180px;width:200px;margin:10px" />
                    <video v-for="(attach,index) in $store.instructionAttachments[dialog.id]" :key="index" :id="'vid-' + index" v-if="attach.type == 'video'" :src="attach.data" @click="upload($event,'editInstVid',index);selectedInstructionVidAttachment(attach.id,index)" style="height:180px;width:200px;margin:10px" controls></video>
                 </div>
                 <div class="videoLink-wrapper" >
                  <div v-for="(attach,index) in $store.instructionAttachments[dialog.id]" v-if="attach.type == 'link'" style="margin-top:5px;padding:5px;">
                    <a :href="attach.data" target="_blank">{{attach.data}}</a>
                    <i class="material-icons right grey-text text-darken-1" @click="deleteAttachmentLink(index)">delete</i>
                  </div>
                </div>
                </div>
            </div>
            <Modal v-if="showDeleteModal" :actions="deleteModalActions" :content="'Entire content(if any) of the dialog will be deleted. Are you sure you want to delete the dialog?'" :header="'Warning'"
            />
            <div v-if="editing" class="editingBox">

                <div class="toolbar">
                    <span v-if="dialog.editor && dialog.created && this.$store.claims.users & 1" class="badge center tooltipped" data-badge-caption=""
                        data-position="top" :data-tooltip="creationInfo">{{editor}}</span>
                    <i @click="showDeleteModal = true" class="material-icons prefix grey-text text-darken-1 left">delete</i>
                    <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
                    <i @click="save()" class="material-icons prefix grey-text text-darken-1">save</i>
                </div>
                <div class="input-field">
                    <img v-if="$store.dialogHasImage[dialog.id]" :src='$store.dialogHasImage[dialog.id]' class="prefix img-icon" width="20" height="20" />
                    <i v-else class="material-icons prefix helen-green-text">{{icon}}</i>
                    <input type="text" placeholder="Search" v-on:keyup="fetchPhraseSuggestion($event)" v-on:focus="fetchPhraseSuggestion($event)"  v-model="editingPhraseText" required />
                    <ul class="suggestion-list">
                        <li v-for="(suggestion,index) in searchSuggestion" :key="index" @click="setSuggestion(suggestion.text)" style="display:flex;flex-direction:column"><div>{{suggestion.text}}</div><div style="font-size:11px;color:#888">{{suggestion.count}} translation(s) available</div></li>
                    </ul>
                </div>
                <div v-if="dialog.type === 'answer'" class="answer-types">
                    <p>Input type</p>
                    <label v-for="(value, type) in inputTypes" :key="type">
                        <input type="radio" :id="type" :value="value" :checked="selected===value" class="filled-in">
                        <span :for="type" @click="uncheck(value)">{{type}}</span>
                    </label>
                </div>
            </div>
            <div v-if="tagEdit" class="editingBox">
                <div class="toolbar">
                    <i class="material-icons prefix grey-text text-darken-1" @click="undoTag">undo</i>
                    <i class="material-icons prefix grey-text text-darken-1" @click="addTag">save</i>
                </div>
                <div v-if="showChips" style="margin-top:5px" class="chip" v-for="(tag,index) in arrTag" :key="index">
                  {{tag}}
                  <i class="material-icons tiny" style="margin-top: 10px" @click="deleteTag(index)">close</i>
                </div>
                <input type="text" v-model="searchTag"  placeholder="Press Enter Key to add Tag" v-on:keyup="tagSearch($event)" v-on:focus="tagSearch($event)" v-on:keyup.enter="inputTag($event)">
                <ul class="suggestion-list">
                  <li v-for="(suggestion,index) in searchArr" :key="index" style="display:flex;flex-direction:column" @click="selectSuggestion(suggestion)">
                    {{suggestion}}
                  </li>
                </ul>
              </div>
            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <treeItem v-for="(id, index) in dialog.next" :key="index" :itemNumber="isStart ? (index+1).toString() : itemNumber+'.'+(index+1)" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="nextDialogs[id]" v-if="nextDialogs[id]"
                />
            </ul>
            <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <treeItem v-for="(d, key) in nextDialogs" :key="key"  :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage" :parentOpen="open" :dialog="d" v-if="dialog.next.indexOf(d.id)<0" />
            </ul>
            <ul v-show="open && empty" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
                <li class="grey-text text-darken-1 text-preview">Empty</li>
            </ul>
        </div>
        <Spinner v-if="loading" :size="'tiny'" />
    </li>
</template>

<style scoped>
#indicatorIcon{
  margin:0px;
  font-weight: bold;
}
.suggestion-list{
  margin:0px;
}
.suggestion-list li{
  padding:10px 5px;
  text-align:justify;
}
.suggestion-list li:hover{
  cursor: pointer;
  background:#efefef;
}
.start {
  padding-left: 0em;
}

ul.start > li > div > ul li {
  border-top: 1px solid #ccc;
  margin-bottom: -1px;
}
ul.start > li > div > ul li:hover {
  border-left: 2px solid dimgray;
  padding-left: 2px;
}
ul.start > li {
  padding: 5px;
  padding-right: 0px;
}
ul.start > li:nth-child(2n + 1) {
  background: #efefef;
  border-left: 2px solid #b7b7b7;
}
ul.start > li:nth-child(2n) {
  border-left: 2px solid #fff;
}
.img-icon {
  width: 20px !important;
}
.root-dialog:hover {
  color: rgba(255, 0, 0, 0.5) !important;
}
.center {
  position: relative;
  margin-left: -50%;
  left: -50%;
}
.secondary-language {
  color: #757575 !important;
}
.answer-types > label {
  margin-right: 1em;
}

.answer-types > p {
  color: darkgray;
}

.icon-spacer {
  width: 24px;
  height: 24px;
  margin-left: 15px;
}

.dialog-tree-list {
  list-style-type: none;
}

.text-preview {
  white-space: nowrap;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-right: 72px;
}

.dialog-tree-row {
  cursor: pointer;
  padding-left: 0;
}

.material-icons {
  display: inline-flex;
  vertical-align: top;
  user-select: none;
}

.editingBox {
  border: 1px solid lightgray;
  padding: 0em 1em 0em 1em;
  margin-right: 1px;
  background: #fff;
}

.edit-icons {
  position: relative;
}
.icon-container {
  position: absolute;
  right: 0;
  top: 0.4em;
}
.toolbar {
  text-align: right;
  margin: 0em -1em 0em -1em;
  padding: 0.5em 1em 0.5em 1em;
  border-bottom: 1px solid lightgray;
}

.toolbar > i {
  margin-left: 0.5em;
}

.toolbar > i:hover {
  color: #6eb2bd !important;
}

.toolbar > .left {
  margin-left: 0;
}

.toolbar > .left:hover {
  color: #e57373 !important;
}
.number-badge {
  font-weight: 300;
  color: #fff;
  background-color: grey;
  border-radius: 2px;
  padding: 0 6px;
  vertical-align: top;
}
.preview-div {
  display: inline-block;
  white-space: normal;
  padding-right: 72px;
}
.instruction-image-wrapper{
    max-height: 212px;
    overflow-x: auto;
    background: white;
    display: flex;
    overflow-y:hidden;
}
.videoLink-wrapper{
  background: white;
  /* display: flex; */
  margin-top: 10px;
  /* overflow-x: auto;
  overflow-y: hidden; */
}
.bg-highlight{
  background: #FFF59D !important;
}
</style>
<script>
import DropDown from "./DropDown";
import Modal from "./Modal";
import Spinner from "./Spinner";
import axios from 'axios';

export default {
  name: "treeItem",
  props: {
    dialog: Object,
    parentOpen: Boolean,
    displaySecondaryLanguage: Boolean,
    secondaryLanguage: String,
    itemNumber: String
  },
  components: {
    DropDown,
    Modal,
    Spinner
  },
  data() {
    return {
      open: false,
      phrase: {},
      nextDialogs: {},
      editing: false,
      editingDialog: null,
      editingPhraseText: "",
      showDeleteModal: false,
      loadingDialogs: true,
      loadingPhrase: true,
      initalized: false,
      deletingRoot: false,
      hidden:false,
      cancelSource:null,
      searchSuggestion:[],
      currentSearchResult:{},
      currentColor: "blue",
      tagEdit: false,
      tags:"",
      searchTag:"",
      arrTag:[],
      showChips: true,
      searchArr:[],
      inputTypes: {
        "Multi-select": "multiselect",
        Number: "input_number",
        Time: "input_time",
        "Rating-scale": "input_rating"
      },

      selected:"",

      dropdownActions: {
        Category: () => {
          this.addDialog("category");
        },
        Question: () => {
          this.addDialog("question");
        },
        Instruction: () => {
          this.addDialog("instruction");
        },
        Answer: () => {
          this.addDialog("answer");
        },
      },
      deleteModalActions: {
        Yes: () => {
          if (this.dialog.new)
            this.removeDialog(this.dialog);
          else {
            this.editing = false;
            this.deleteRootDialog();
          }
          this.showDeleteModal = false;
          this.deletingRoot = false;
        },
        No: () => {
          this.showDeleteModal = false;
        }
      }
    };
  },
  watch: {
    parentOpen: function(isOpen) {
      if (!isOpen) {
        this.open = false;
      } else if (!this.initialized) {
        if(this.dialog.next)
        this.getNext()
          .then(() => (this.loadingDialogs = false))
          .catch(() => (this.loadingDialogs = false));
        this.initialized = true;
      }
    },
    "dialog.phrase": function(id) {
      this.getPhraseByID(id);
    },
    "dialog.next": function(list) {
        this.nextDialogs = Object.keys(this.nextDialogs)
          .filter(d => {
            return (
              this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 ||
              this.nextDialogs[d].new
            );
          })
          .reduce((obj, key) => {
            obj[key] = this.nextDialogs[key];
            return obj;
          }, {});
        var newDialogs = [];
        if(this.dialog.next)
          this.dialog.next.forEach(id => {
              if (!this.nextDialogs[id]) {
              newDialogs.push(id);
            }
          });
        newDialogs.forEach(element => {
          this.getDialogByID(element);
        });
    }
  },
  mounted(){
    var elems = document.querySelectorAll('.dropdown-trigg');
    var instances = M.Dropdown.init(elems, {});
    this.changeColor(this.criticalLevel());
  },
  methods: {
    selectedInstructionAttachment(attachmentId,attachmentIndex){
      this.$store.instructionImgselected = true;
      this.$store.instructionImg = [];
      var imgProp = 
      {
        id: "",
        index: ""
      };
      imgProp.id = attachmentId;
      imgProp.index = attachmentIndex;

      this.$store.instructionImg.push(imgProp)
    },
    selectedInstructionVidAttachment(attachIdVid,attachIndexVid){
      this.$store.instructionVidselected = true;
      this.$store.instructionVid = [];

      var vidProp = 
      {
        id: "",
        index: ""
      };
      vidProp.id = attachIdVid;
      vidProp.index = attachIndexVid;

      this.$store.instructionVid.push(vidProp)
    },
    uncheck: function(val) {
       if (val === this.selected) {
        this.selected = false;
        var index =this.editingDialog.tags.indexOf(val)
        this.editingDialog.tags.splice(index,1)
      }else {
        var statusTagUpdt = true;
        this.selected = val;
        const inputType = Object.values(this.inputTypes)
        inputType.forEach(element => {
          if(this.editingDialog.tags.indexOf(element) >= 0){
            var indEdit = this.editingDialog.tags.indexOf(element)
            this.editingDialog.tags[indEdit]=val;
            statusTagUpdt = false;
          }
        });
        if(statusTagUpdt){
          this.editingDialog.tags.unshift(val)
        }
      }
    },
    changeColor(val){
      if(val == 1){
        this.currentColor = "green";
      }if(val == 2){
        this.currentColor = "darkseagreen";
      }if(val == 3){
       this.currentColor= "orange";
      }if(val == 4){
       this.currentColor = "orangered";
      }if(val == 5){
        this.currentColor = "red";
      }if(val == -1){
        this.currentColor = " "
      }
    },
    criticalLevel(){
       var level = -1;
       if(this.dialog.tags ){
         this.dialog.tags.forEach((element, i) => {
            if(element.includes("critical:")){
              level = element.charAt(element.length-1)
                }
        })
       }
       return level == -1 ? level : parseInt(level) + 1;
    },
    critcalLevelIndicator(level,id){
      var updated_dialog = {}
      var critical_level = ""
      var status =  false;

      if(this.dialog.tags === null || this.dialog.tags.length == 0){
          this.dialog.tags = []
          critical_level = "critical:" + level
          
          this.dialog.tags.push(critical_level)

          updated_dialog = Object.assign({},this.dialog);
        }else{
          var index = -1;
          critical_level = "critical:" + level

          this.dialog.tags.forEach((element, i) => {
            if(element.includes("critical:")){
              index = i;
            }
            })
            if(index >= 0){
              this.dialog.tags.splice(index, 1, critical_level);
            }else{
              this.dialog.tags.push(critical_level)
            }
            updated_dialog = Object.assign({},this.dialog);
        }
        this.$store
          .putDialog(updated_dialog)
          .then(r => {
            this.changeColor(this.criticalLevel())
          })
          .catch(() => this.toast("Could not update dialog"));
    },
    setSuggestion(suggestion){
      this.editingPhraseText = suggestion;
      this.searchSuggestion = []
    },
    fetchPhraseSuggestion(event){
      var searchQuery =  this.editingPhraseText;
      if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
      }
      this.cancelSource = axios.CancelToken.source();
      if(searchQuery.length==0){
        this.searchSuggestion=[];
        return;
      }
     this.$http.get('search/phraseSearch?text=' + searchQuery +'&lang_id='+this.$store.preferredLanguage, {
        cancelToken: this.cancelSource.token,
        headers: {
          type:'phrase'
        }
      }).then((r) => {
          if (r) {
            this.cancelSource = null;
            var vm = this;
            var phrases = [];
            r.data.forEach(function(phrase){
              phrase.translations.forEach(function(translation){
                if(translation.language == vm.$store.preferredLanguage){
                    var obj = {
                      text:translation.text,
                      count:phrase.translations.length
                    };
                    phrases.push(obj);
                    vm.currentSearchResult[translation.text] = phrase;
                }
              })
            })
            this.searchSuggestion = phrases;
          }
        }, err => {});
  },
    hideDialog(){
       this.loadingDialogs = true;
       this.$http.post("/dialogs/"+this.dialog.id+"/hide").then(()=>{
              this.dialog.tags = this.dialog.tags ? this.dialog.tags : [];
              this.hidden = true;
              this.dialog.tags.push("hidden");
              this.loadingDialogs = false;
       })
        
    },
    unhideDialog(){
       if(this.$parent.hidden)
        return
       this.loadingDialogs = true;
       this.$http.post("/dialogs/"+this.dialog.id+"/unhide").then(()=>{
              this.dialog.tags = this.dialog.tags ? this.dialog.tags : [];
              this.hidden = false;
              if(this.dialog.tags.indexOf("hidden") > -1)
                  this.dialog.tags.splice(this.dialog.tags.indexOf("hidden"), 1); 
              this.loadingDialogs = false;
       }) 
       
    },
    isHidden(){
      if(this.$parent.hidden){
       this.hidden = true; 
       return true
      }
      if(this.$parent.dialog && this.$parent.dialog.tags && this.$parent.dialog.tags.indexOf("hidden") > -1){
       this.hidden = true; 
       return true
      } 
      if(this.dialog.tags && this.dialog.tags.indexOf("hidden") > -1){
       this.hidden = true; 
       return true
      }
      this.hidden = false
      return false 
    },
    deleteRootDialog(vm) {
      var d = vm ? vm : this;
      d.$parent.$emit("delete:dialog", d.dialog);
    },
    getSubDialogsId(arr, subNodes, count, rootDialogId) {
      var vm = this;
      arr.forEach(element => {
        this.$store.getDialogbyID(element).then(r => {
          count.c--;
          if (r.data.next) {
            r.data.next.forEach(element => {
              subNodes.push(element);
            });
            count.c += r.data.next.length;
            this.getSubDialogsId(r.data.next, subNodes, count, rootDialogId);
          }
          if (count.c === 0) {
            vm.$store.deleteDialog(rootDialogId);
            vm.deleteSubNodes(subNodes);
          }
        });
      });
    },
    deleteSubNodes(nodes) {
      nodes.forEach(element => {
        this.$store.deleteDialog(element);
      });
    },
    upload(el, icon, instAttachIndex) {
      this.$store.currentDialogRef = this;
      if (icon == "chat" || icon == "fromimage") {
        this.$store.uploadingInstructionImage = false;
        this.$store.currentDialogId = el.path[0].id;
        if (icon == "fromimage") {
          this.$store.changeDeleteImage = true;
          this.$store.uploadDialogImgSrc = this.$store.dialogHasImage[
            this.$store.currentDialogId
          ];
          this.$store.imageChosen=true;
        } else {
          this.$store.changeDeleteImage = false;
          this.$store.uploadDialogImgSrc = "";
        }
        this.$store.answerImageUploadDialog=true;
        this.$store.showUploadImageDialog = true;
        this.$store.imageChosen = true;
        this.$store.videoChosen = false;
        this.$store.linkChosen = false;
      }
      if(icon == "feedback"){
        this.$store.uploadingInstructionImage = true;
        this.$store.currentDialogId = this.dialog.id;
        this.$store.showUploadImageDialog = true;
        this.$store.editingInstImg = false;
        this.$store.changeDeleteImage = false;
        this.$store.uploadDialogImgSrc = "";
        this.$store.imageChosen = true;
        this.$store.videoChosen = true;
        this.$store.linkChosen = true;
      }
      if(icon == "editInstImg"){
          this.$store.changeDeleteImage = true;
          this.$store.uploadingInstructionImage = true;
          this.$store.currentDialogId = this.dialog.id;
          var attachArr = this.$store.instructionAttachments[this.dialog.id];
          this.$store.uploadDialogImgSrc = attachArr[instAttachIndex].data;
          this.$store.editingInstImgIndex = instAttachIndex; 
          this.$store.imageChosen = true;
          this.$store.videoChosen = false;
          this.$store.editingInstImg = true;
          this.$store.showUploadImageDialog = true;
          this.$store.linkChosen = false;

      }
      if(icon == 'editInstVid'){
        this.$store.changeDeleteVideo = true;
        this.$store.currentDialogId = this.dialog.id;
        var attachArr = this.$store.instructionAttachments[this.dialog.id];
        this.$store.uploadDialogVidSrc = attachArr[instAttachIndex].data;
        this.$store.editingInstVidIndex = instAttachIndex; 

        this.$store.videoChosen = true;
        this.$store.imageChosen = false;
        this.$store.editingInstVid=true;
        this.$store.showUploadImageDialog= true;
        this.$store.linkChosen = false;

      }
    },
    deleteAttachmentLink(index){
        var attachArray = this.$store.instructionAttachments[this.dialog.id];
        var attach = attachArray[index];
        var vm = this;
        this.$http.delete("/dialogs/" + this.dialog.id + "/attachmentsText/"+ attach.id).then(function(r){
        attachArray.splice(index, 1);
        vm.$set(vm.$store.instructionAttachments,vm.dialog.id,attachArray);
      })
    },
    onDragStart(ev) {
      this.$store.draggedDialog = this;
      ev.dataTransfer.setData("text/plain", JSON.stringify(this.dialog));
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    /**
     * Handle drop of dialogs
     * @param {Object} ev Incomming event
     */
    async onDrop(ev) {
      if (!this.$store.reorder) {
        try {
          var dialog = JSON.parse(ev.dataTransfer.getData("text"));
        } catch {
          return;
        }
        if (this.dialog.id === dialog.id || this.dialog.new || dialog.new)
          return;
        if(this.$store.moveDialog) {
          const draggedId = dialog.id;
          const droppedId = this.dialog.id;
          this.dialog.next = this.dialog.next ? this.dialog.next : [];
          this.dialog.next.push(draggedId);
          var vm = this;
          this.$http.put("/dialogs/" + this.dialog.id, this.dialog).then(r => {
            vm.$store.draggedDialog.$parent.$emit("delete:dialog", vm.$store.draggedDialog.dialog);
          });
          return;
        } 
        if (this.dialog.next && this.dialog.next.indexOf(dialog.id) < 0) {
          var count = dialog.next?{c:dialog.next.length}:{c:0};
          var replicateddialog = { d: "" };
          var dropdialog = this.dialog.id;
          this.loadingDialogs = true;
          await this.replicate(dialog.id, count, dropdialog, replicateddialog);
          this.addReplicatedDialog(replicateddialog, dropdialog);
        } else if (this.dialog.next) {
          var newDialog = JSON.parse(JSON.stringify(this.dialog));
          newDialog.next.splice(newDialog.next.indexOf(dialog.id), 1);
          newDialog.next.push(dialog.id);
          this.$parent.$emit("update:dialog", newDialog);
        } else return;
        this.open = true;
      } else {
        var dialog = JSON.parse(ev.dataTransfer.getData("text"));
        const draggedId = dialog.id;
        const droppedId = this.dialog.id;
        if (
          this.$store.dialogParent[draggedId] !=
          this.$store.dialogParent[droppedId]
        )
          return;
        const parentId = this.$parent.dialog.id;
        var next = this.$parent.dialog.next;
        var indexDragged = next.indexOf(draggedId);
        var indexDropped = next.indexOf(droppedId);
        if (indexDropped < indexDragged) {
          next.splice(indexDropped, 0, draggedId);
          next.splice(indexDragged + 1, 1);
        } else {
          next.splice(indexDropped + 1, 0, draggedId);
          next.splice(indexDragged, 1);
        }
        this.$http.put("/dialogs/" + parentId, this.$parent.dialog);
      }
    },
    
    async replicate(
      dialog,
      count,
      dropdialog,
      replicateddialog,
      parentdata,
      newparentId,
      index
    ) {
      var vm = this;
      var res = {};
      await this.$store.getDialogById(dialog).then(r => { 
        res = r;
        }).catch(() => toast("Could not replicate dialog"));
        var next = res.data.next ? res.data.next.slice() : [];
        var currentParent = "";
        res.data.next = [];
        currentParent = res.data;
        var prevId = null;
        if(res.data.attachments && res.data.attachments.length>0)
          prevId = res.data.id;
        var resp; //resp in new dialog id
        await vm.$store.postDialog(res.data).then(r => { resp = r; });
        if(res.data.attachments){
          if(res.data.type == "answer"){
            res.data.attachments.forEach(async (a,index) => {
            var imgBase = null;
            await vm.$http.get("/dialogs/" + res.data.id + "/attachments/" + a.id, {responseType: "arraybuffer"})
            .then(response => {
                let img = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
                imgBase = `data:${response.headers["content-type"].toLowerCase()};base64,${img}`;
                vm.$set(vm.$store.dialogHasAttachment,resp,res.data.attachments[0].id);
                vm.$set(vm.$store.dialogHasImage,resp,imgBase);
            })
          })
          }else if(res.data.type == "instruction"){
            var attchments = [];
            for(let i = 0; i<res.data.attachments.length; i++){
              var a = res.data.attachments[i];
              var attachBase = null;
            var attchObj = null;
            if(a.contentType.indexOf("image") >= 0){
               await vm.$http.get("/dialogs/" + res.data.id + "/attachments/" + a.id, {responseType: "arraybuffer"})
                .then(response => {
                let attch = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
                attachBase = `data:${response.headers["content-type"].toLowerCase()};base64,${attch}`; 
                attchObj = {
                 type:"image",
                 data:attachBase,
                 id:a.id
                };
              })
            }
            if(a.contentType.indexOf("video") >= 0 || a.contentType.indexOf("application/octet-stream") >= 0){
               await vm.$http.get("/dialogs/" + res.data.id + "/attachments/" + a.id, {responseType: "arraybuffer"})
                .then(response => {
                let attch = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
                attachBase = `data:${response.headers["content-type"].toLowerCase()};base64,${attch}`; 
                attchObj = {
                 type:"video",
                 data:attachBase,
                 id:a.id
                };
              })
            }
            if(a.contentType.indexOf("text") >= 0){
              attchObj = {
                 type:"link",
                 data:a.filename,
                 id:a.id
              };
            }
            attchments.push(attchObj);
            }
            vm.$set(vm.$store.instructionAttachments,resp,attchments)
          }
      }
         
          if (replicateddialog.d == "") replicateddialog.d = resp;
          count.c--;
          if (parentdata) {
            var nextUpdateId = resp;
            parentdata.next[index] = nextUpdateId;
            vm.$set(this.$store.dialogParent, resp, newparentId);
            parentdata.id = newparentId
            await vm.$store.putDialog(parentdata);
          }
          var currentParentId = resp;
          if (parentdata) count.c += next.length;
          if (next.length) {
            for(let index = 0; index<next.length; index++)
              await vm.replicate(
                next[index],
                count,
                dropdialog,
                replicateddialog,
                currentParent,
                currentParentId,
                index
              )
          }
    },
    addReplicatedDialog(replicateddialog, dropdialog){
      var vm = this;
       vm.$http.get("dialogs/" + replicateddialog.d).then(r => {
              vm.$set(vm.nextDialogs, r.data.id, r.data);
              this.$set(this.$store.dialogParent, r.data.id, vm.dialog.id);
              vm.dialog.next.push(r.data.id);
              if (!vm.$store.moveDialog) {
                var copyRecord = {
                  type: "copy",
                  copied: vm.$store.draggedDialog.dialog.id,
                  replicated: replicateddialog.d
                };
                if (vm.$store.undoStack.length === 5)
                  vm.$store.undoStack.splice(0, 1);
                vm.$store.undoStack.push(copyRecord);
              }
              vm.$http.put("/dialogs/" + dropdialog, vm.dialog).then(r => {});
            });
            if (vm.$store.moveDialog) {
              vm.deleteRootDialog(vm.$store.draggedDialog);
            }
            this.loadingDialogs = false;
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    },
    /**
     * Toggle folder state
     */
    toggle() {
      this.open = !this.open || this.isStart;
    },
    /**
     * Fetch dialog based on ID
     * @param {string} id ID of dialog to fetch
     */
    getDialogByID(id) {
      this.$set(this.$store.dialogRef, this.dialog.id, this);
      return new Promise((resolve, reject) => {
        this.$http.get("dialogs/"+id).then(
          response => {
            if (!response.data.next) response.data.next = [];
            this.$set(this.nextDialogs, id, response.data);
            if (
              response.data.type == "answer" &&
              response.data.attachments &&
              response.data.attachments.length > 0
            ) {
              this.$set(
                this.$store.dialogHasAttachment,
                response.data.id,
                response.data.attachments[0].id
              );
              this.updateDialogHasImage(
                response.data.attachments[0].id,
                response.data.id
              );
            }
            if(response.data.type == "instruction" && response.data.attachments && response.data.attachments.length > 0){
              this.updateInstructionAttachments(response.data.attachments,response.data.id);
            }
            if (response.data.next && response.data.next.length>0) {
              response.data.next.forEach(element => {
                this.$set(this.$store.dialogParent, element, response.data.id);
              });
            }
            resolve();
          },
          response => {
            reject();
          }
        );
      });
    },

    updateDialogHasImage(imageId, answerId) {
      var vm = this;
      this.$http
        .get("/dialogs/" + answerId + "/attachments/" + imageId, {
          responseType: "arraybuffer"
        })
        .then(response => {
          let image = btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          var dialogImg = `data:${response.headers[
            "content-type"
          ].toLowerCase()};base64,${image}`;
          vm.$set(vm.$store.dialogHasImage, answerId, dialogImg);
        })
        .catch(function() {
          vm.$delete(vm.$store.dialogHasImage, answerId);
          vm.$delete(vm.$store.dialogHasAttachment, answerId);
        });
    },
    async updateInstructionAttachments(attachments,instructionId){
      var vm = this;
      vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
      vm.$set(vm.$store.instructionAttachments,instructionId,[]);
      for(let i=0;i<attachments.length;i++){
        if(attachments[i].contentType.indexOf("image") >= 0){
          await this.getImageAttachment(attachments[i].id,i,instructionId);
        }
        if(attachments[i].contentType.indexOf("video") >= 0 || attachments[i].contentType.indexOf("application/octet-stream") >= 0){
          await this.getVideoAttachment(attachments[i].id,i,instructionId);
        }
        if(attachments[i].contentType.indexOf("text") >= 0){
           var obj = {
            type:"link",
            data:attachments[i].filename,
            id:attachments[i].id
          };
          var vm = this;
          vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
          var instAttachments = vm.$store.instructionAttachments[instructionId] ? vm.$store.instructionAttachments[instructionId] : [];
          instAttachments.push(obj); 
          vm.$set(vm.$store.instructionAttachments,instructionId,instAttachments);
        }
      }
    },
    getImageAttachment(id,i,instructionId){
     var vm = this;
     return new Promise((resolve,reject)=>{
       this.$http.get("dialogs/" + instructionId + "/attachments/" + id, {
          responseType: "arraybuffer"
        }).then(response=>{
          let image = btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          var instImg = `data:${response.headers[
            "content-type"
          ].toLowerCase()};base64,${image}`;

          var obj = {
            type:"image",
            data:instImg,
            id:id
          };

          vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
          var instAttachments = vm.$store.instructionAttachments[instructionId] ? vm.$store.instructionAttachments[instructionId] : [];
          instAttachments.push(obj); 
          vm.$set(vm.$store.instructionAttachments,instructionId,instAttachments);
          
          var imageArray = vm.$store.instructionImages[instructionId] ? vm.$store.instructionImages[instructionId] : [];
          var imageIdArray = vm.$store.instructionImagesId[instructionId] ? vm.$store.instructionImagesId[instructionId] : [];
          if(i==0){
             imageArray = [];
             imageIdArray = [];
          }
          imageArray.splice(i,0,instImg);
          imageIdArray.splice(i,0,id);
          vm.$set(vm.$store.instructionImages,instructionId,imageArray);
          vm.$set(vm.$store.instructionImagesId,instructionId,imageIdArray);
         resolve();
       },
       r=>{
         resolve();
       })
     })
    },
    getVideoAttachment(id,i,instructionId){
      var vm=this;
      return new Promise((resolve,reject)=>{
        this.$http.get("dialogs/"+instructionId+"/attachments/"+id,{
          responseType:"arraybuffer"
        }).then(response=>{
          let video=btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          var instVid = `data:${response.headers[
            "content-type"
          ].toLowerCase()};base64,${video}`;
          var videoArray = vm.$store.instructionVideos[instructionId] ? vm.$store.instructionVideos[instructionId] : [];
          var videoIdArray = vm.$store.instructionVideosId[instructionId] ? vm.$store.instructionVideosId[instructionId] : [];
          
          var videoPresent=true;
          if(videoIdArray.length==0){
            videoPresent=false;
          }else{
            if(vm.$store.instructionVideosId[instructionId].indexOf(id)==-1){
              videoPresent=false;
            }
          }

          var obj = {
            type:"video",
            data:instVid,
            id:id
          };

          vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
          var instAttachments = vm.$store.instructionAttachments[instructionId] ? vm.$store.instructionAttachments[instructionId] : [];
          instAttachments.push(obj); 
          vm.$set(vm.$store.instructionAttachments,instructionId,instAttachments);

          if(!videoPresent){
            videoArray.splice(videoArray.length,0,instVid);
            videoIdArray.splice(videoIdArray.length,0,id);
            vm.$set(vm.$store.instructionVideos,instructionId,videoArray);
            vm.$set(vm.$store.instructionVideosId,instructionId,videoIdArray);
          }
         resolve();
        },
        r=>{
         resolve();
       })
      })
    },
    /**
     * Fetch phrase based on ID
     * @param {number} id ID of pharse to fetch
     */
    getPhraseByID(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve();
          return;
        }
          const storedPhrase = this.$store.phrases.filter(p => p.id === id)[0];
        if (storedPhrase) {
          this.phrase = storedPhrase;
          resolve();
        } else
          this.$http.get("/phrases/" + id).then(
            response => {
              this.phrase = response.data;
              this.$store.phrases.push(response.data);
              resolve();
            },
            response => {
              reject();
            }
          );
      });
    },
    /**
     * Append a new dialog with the this dialog as parent
     * @param {string} type The type of the new dialog
     */
    addDialog(type) {
      this.open = true;
      const tempID = Math.random()
        .toString(36)
        .substr(2, 9);
      this.$set(this.nextDialogs, tempID, {
        id: tempID,
        new: true,
        editor: this.$store.userID,
        creator: this.$store.userID,
        phrase: null,
        next: [],
        tags: [],
        type: type
      });
    },
    /**
     * Toggle editing state
     */
    edit() {
      this.editing = !this.editing;
      if (this.editing) {
        this.editingDialog = Object.assign({}, this.dialog);
        this.editingPhraseText = this.primaryEditingTranslation;
        this.editingDialog.tags =
          this.editingDialog.tags == undefined ? [] : this.editingDialog.tags;
        this.editingDialog.editor = this.$store.userID;
      }
    },
    editTag(){
      if(this.primaryTranslation != "Phrase has no translation for this language"){
      this.tagEdit = true;
      this.showChips = true;
      this.arrTag = []
      this.$http.get("/search/tag?lid="+this.$store.preferredLanguage+"&did="+this.dialog.id)
      .then(response => {
      response.data.tags.forEach(element => {
        this.arrTag.push(element)
      });
      if(this.arrTag[0] == '' && this.arrTag.length <= 1){
        this.arrTag = []
      }
      })
      .catch(() => this.toast("request Failed"));
      }else{
        M.toast(
          {
            html:"Tag cannot be added as the dialog doesn't exist for particular language"
          }
        )
      }
    },
    undoTag(){
      this.tagEdit = false;
    },
    addTag(){
      this.showChips = true;
      var tagArray = this.arrTag.join(' ')
      var tagObj = 
      { 
        "dialog": this.dialog.id,
        "language": this.$store.preferredLanguage,
        "tag": tagArray
      }
      this.$http.put("/search/tag",tagObj) 
      .then(response => {
        this.tagEdit = false;
      })
      .catch(() => this.toast("request Failed"));
    },
    tagSearch(event){
      this.searchArr = [];
      var tagSearch = this.searchTag
       this.$http.get("/search/tagSearch?stag="+tagSearch+"&lid="+this.$store.preferredLanguage) 
      .then(response => {
        response.data.tags.forEach(element => {
          this.searchArr.push(element);
        });
      })
      .catch(() => this.toast("request Failed"));
    },
    selectSuggestion(suggestion){
    this.searchTag = suggestion;
    },
    inputTag(event){
      if(this.searchTag != ""){
      var tag = this.searchTag
      this.arrTag.push(tag)
      this.searchTag = ""
      this.searchArr= [];
      }
      else{
        M.toast(
          {
            html:"empty value Cannot be taken"
          }
        )
      }
    },
    deleteTag(ind){
      this.arrTag.splice(ind,1);
    },
    /**
     * Call for saving changes to current dialog
     */
    save() {
      if (this.editingPhraseText.length < 1) {
        this.toast("You can't add an empty phrase");
        return;
      }
      var existingPhrase = this.currentSearchResult[this.editingPhraseText] ? this.currentSearchResult[this.editingPhraseText] : null;
      if(!existingPhrase || existingPhrase.length == 0){
      var existingPhrases = this.$store.phrases.filter(p => {
          var found = false;
          for(let i=0; i<p.translations.length; i++){
            if(p.translations[i].text == this.editingPhraseText) {
              found = true;
              break;
            }
          }
          return found;
        }) 
        var index = null;
        var length = -1;
        existingPhrases.forEach((p, i) => {
          if(p.translations && p.translations.length > length){
            length = p.translations.length;
            index = i;
          }
        })
        if(index != null){
          existingPhrase = existingPhrases[index];
        }else{
          existingPhrase = null;
        }
      }
      if (existingPhrase) {
        this.editingDialog.phrase = existingPhrase.id;
        this.$parent.$emit("update:dialog", this.editingDialog);
      } else {
        this.loadingPhrase = true;
        this.createNewPhrase(
          this.editingPhraseText,
          this.$store.preferredLanguage
        )
          .then(id => {
            this.editingDialog.phrase = id;
            this.$parent.$emit("update:dialog", this.editingDialog);
            this.loadingPhrase = false;
          })
          .catch(() => this.toast("Could not add new phrase"));
      }
      this.editing = false;
    },
    /**
     * Call for saving changes to current dialog
     */
    removeDialog(dialog) {
      if (!dialog.new)
        this.$store
          .deleteDialog(dialog.id)
          .then(() => {
            this.$parent.$emit("delete:dialog", this.dialog);
            this.editing = false;
          })
          .catch(() => this.toast("Could not delete dialog"));
      else this.$parent.$emit("delete:dialog", this.dialog);
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogUpdate(dialog) {
      if (dialog.new) {
        this.loadingDialogs = true;
        delete dialog.new;
        this.$store
          .postDialog(dialog)
          .then(id => {
            this.$set(this.$store.dialogParent, id, this.dialog.id);
            this.$set(this.$store.dialogRef, id, this);
            this.$delete(this.nextDialogs, dialog.id);
            dialog.id = id;
            (dialog.created = new Date().toISOString()),
              this.$set(this.nextDialogs, dialog.id, dialog);
            var newDialog = JSON.parse(JSON.stringify(this.dialog));
            newDialog.next.push(dialog.id);
            this.$store
              .putDialog(newDialog)
              .then(() => {
                this.dialog.next.push(id);
                this.loadingDialogs = false;
              })
              .catch(() => {
                this.toast("Could not add dialog");
                this.dialog.next.push(id);
              });
          })
          .catch(() => this.toast("Could not add dialog"));
      } else
        this.$store
          .putDialog(dialog)
          .then(() => {
            this.$set(this.nextDialogs, dialog.id, dialog);
            this.$set(this.$store.dialogRef, dialog.id, this);
            this.$set(this.$store.dialogParent, dialog.id, this.dialog.id);
          })
          .catch(() => this.toast("Could not update dialog"));
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogDelete(dialog) {
      if (dialog.new) this.$delete(this.nextDialogs, dialog.id);
      else {
        var newDialog = JSON.parse(JSON.stringify(this.dialog));
          newDialog.next = newDialog.next.filter(it => it !== dialog.id);
        this.$store
          .putDialog(newDialog)
          .then(() => {
              this.dialog.next = this.dialog.next.filter(it => it != dialog.id);
            this.$delete(this.nextDialogs, dialog.id);
          })
          .catch(() => this.toast("Could not delete dialog"));
      }
    },
    /**
     * Prepare a phrase for posting and if success add it to the store
     * @param {string} translationText Text of translation
     * @param {string} translationLanguage Language of translation
     */
    createNewPhrase(translationText, translationLanguage) {
      return new Promise((resolve, reject) => {
        var phrase = {
          translations: [
            {
              text: translationText,
              language: translationLanguage
            }
          ]
        };
        this.$store
          .postPhrase(phrase)
          .then(id => {
            phrase.id = id;
            resolve(id);
          })
          .catch(() => reject(Error("Could not add phrase")));
      });
    },
    /**
     * Retireves the next dialogs
     */
    getNext() {
      return new Promise((resolve, reject) => {
        var a = this.dialog.next.map(id => {
          return this.getDialogByID(id);
        });
        Promise.all(a).then(() => resolve());
      });
    },
    toast(text) {
      M.toast({
        html: text
      });
    }
  },
  /**
   * Intitialize the component
   */
  created() {
    this.$on("update:dialog", d => this.handleDialogUpdate(d));
    this.$on("delete:dialog", d => this.handleDialogDelete(d));
    if (this.isStart) this.open = true;
    if (this.dialog.new) this.edit();
    this.getPhraseByID(this.dialog.phrase)
      .then(() => (this.loadingPhrase = false))
      .catch(() => (this.loadingPhrase = false));
    if (this.parentOpen) {
      if(this.dialog.next)
      this.getNext()
        .then(() => {
          this.loadingDialogs = false;
          this.initialized = true;
        })
        .catch(() => {
          this.loadingDialogs = false;
          this.toast("Could not fetch the next set of dialogs");
        });
        else{
          this.loadingDialogs = false;
          this.initialized = true;
        }
    }
  },
  /**
   * Handle Materialize components on graphical update
   */
  updated() {
    var autoCompletes = this.$el.querySelectorAll(".autocomplete");
    if (autoCompletes) {
      M.Autocomplete.init(autoCompletes, {
        data: this.$store.autocompletePhrases,
        onAutocomplete: val => {
          this.editingPhraseText = val;
        },
        limit: 10
      });
    }
    var tooltips = document.querySelectorAll(".tooltipped");
    if (tooltips) M.Tooltip.init(tooltips, {});
    var elems = document.querySelectorAll('.dropdown-trigg');
    var instances = M.Dropdown.init(elems, {});
    this.$nextTick(function(){
      var elems = document.querySelectorAll('.chips');
      var instances = M.Chips.init(elems, {});    
      });
  },
  computed: {
    /**
     * Get translation based on current preferred language
     */
    secondaryTranslation() {
      if (this.isStart) return "";

      if (this.secondaryLanguage === "")
        return "No secondary language is selected";

      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          t => t.language === this.secondaryLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for the secondary language";
    },
    /**
     * Get translation based on current preferred language
     */
    primaryTranslation() {
      if (this.isStart) return "Root";
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          t => t.language === this.$store.preferredLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for this language";
    },

    /**
     * Get translation based on current preferred language (if none found => '')
     */
    primaryEditingTranslation() {
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          t => t.language === this.$store.preferredLanguage
        )[0];
      return foundTranslation ? foundTranslation.text : "";
    },
    /**
     * Get icon based on dialog's type
     */
    icon() {
      const types = {
        answer: "chat",
        instruction: "feedback",
        question: "help",
        category: "folder",
        start: "view_list",
        default: "error"
      };
      return (
        types[this.dialog.type] || types[this.isStart ? "start" : "default"]
      );
    },
    /**
     * Returns last editor of dialog
     */
    editor() {
        const modifier = this.$store.users.filter(
        u => u.id === this.dialog.editor
      )[0];
      return modifier ? modifier.username : "";
    },
    creationInfo() {

        const creator = this.$store.users.filter(
          u => u.id === this.dialog.creator
        )[0];
      return creator && this.dialog.created
        ? "Created by " +
            creator.username +
            " ( " +
            this.dialog.created.split("T")[0] +
            " " +
            this.dialog.created.split("T")[1].slice(0, 5) +
            " )"
        : "";
    },
    /**
     * Get empty state of nextDialogs
     */
    empty() {
      for (var key in this.nextDialogs) {
        if (this.nextDialogs.hasOwnProperty(key)) return false;
      }
      return true;
    },
    /**
     * Returns if dialog is start-dialog
     */
    isStart() {
      return this.dialog.tags && this.dialog.tags.indexOf("start") > -1;
    },
    /**
     * Returns if the dialog is loading
     */
    loading() {
      return this.loadingPhrase || this.loadingDialogs;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TreeItem.vue